import apiClient from './apiClient';
import { GET_CAREERS_SETTINGS, UPDATE_CAREERS_SETTINGS } from '../constants/UriConstants';
import { CareersSettingsInterface, UpdateCareersSettingsRequest } from '../types/CareersSettingsInterface';

export const getCareersSettings = (): Promise<CareersSettingsInterface> =>
  apiClient.get(GET_CAREERS_SETTINGS).then((response) => response.data);

export const updateCareersSettings = (update: UpdateCareersSettingsRequest): Promise<CareersSettingsInterface> =>
  apiClient.put(UPDATE_CAREERS_SETTINGS, update).then((response) => response.data);
